module.exports = __webpack_public_path__ + "img/remind.3bcba02d.svg";